export default __webpack_public_path__ + "static/media/backdrop.f72d3a39.svg";